import { isEmptyObject } from './formValidators';
import * as validators from './formValidators';

export const validateDynamicForm = (values, fieldsMap) => {
    let errors = {};
    if (isEmptyObject(values) || !fieldsMap) {
        return errors;
    }

    for (let i = 0; i < fieldsMap.length; i++) {
        const field = fieldsMap[i];
        const name = fieldsMap[i].name;
        const value = values[name];
        const type = field.type;
        const required = !!(field.props && field.props.required);
        let error;
        if (required) {
            error = validators.validateRequired(value, name);
            if (!isEmptyObject(error)) {
                errors = { ...errors, ...error };
                continue;
            }
        }

        switch (type) {
        case 'TextArea':
            error = validators.validateText(value, name, 50000);
            break;

        case 'Email':
            error = validators.validateEmail(value, name);
            break;

        case 'Contact':
            break;

        default:
            error = validators.validateText(value, name, 100);
            break;
        }

        if (validators.isEmptyObject(error)) {
            continue;
        }

        errors = { ...errors, ...error };
    }

    return errors;
};
